import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ROUTE_member_login, ROUTE_blank } from "./Routes";
import { AuthDAO } from "./dao/AuthDAO";
import { UserInfoDTO } from "./dao/DTOs";

type Props = {
  adminOnly: boolean;
  children?: JSX.Element;
};

function AuthRequiredRoute({ adminOnly, children }: Props): JSX.Element {
  const [user, setUser] = useState<UserInfoDTO | null>(null);
  const [loadingState, setLoadingState] = useState<boolean>(true);

  useEffect(() => {
    AuthDAO.Info()
      .then((res) => {
        setUser(res);
      })
      .catch((error) => {
        setUser(null);
      })
      .finally(() => {
        setLoadingState(false);
      });
  }, []);

  if (loadingState) {
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題
    return <></>;
  }

  if (!user) {
    return adminOnly ? (
      <Navigate to={ROUTE_blank.url} /> // 不引導到登入頁，請內部人員自己把登入頁加入我的最愛
    ) : (
      <Navigate to={ROUTE_member_login.url} />
    );
  }

  if (adminOnly && user?.role !== "admin") {
    return <Navigate to={ROUTE_blank.url} /> // 不引導到登入頁，請內部人員自己把登入頁加入我的最愛
  }


  return children ? children : <Outlet />;
}

export default AuthRequiredRoute;
